module.exports = __webpack_public_path__ + "img/setProgressives.7a1bb8a5.png";